import * as actionTypes from './types';

/**
 * @typedef WorkingCapitalAcceptancePayload
 * @type {object}
 * @property {number} offerId
 * @property {number} acceptedAmount - 0 signals a rejection of the offer
 * @property {number | null} [acceptedHoldbackRate]
 * @property {number | null} [acceptedNumOfRepayments]
 * @property {string} [rejectionReason] - optional on a rejection (acceptedAmount 0); max 200 chars.
 *   Omitted entirely when the payee gives no reason.
 * @property {object | null} [disclosureValues] - snapshot of the figures shown in the
 *   accepted T&Cs + state disclosures, stored as jsonb and replayed on re-download.
 *   Omitted on a rejection.
 */

export const workingCapitalAcceptanceStart = (offerId) => ({
    type: actionTypes.WORKING_CAPITAL_ACCEPTANCE_START,
    offerId,
});

export const workingCapitalAcceptanceSuccess = (offerId, data) => ({
    type: actionTypes.WORKING_CAPITAL_ACCEPTANCE_SUCCESS,
    offerId,
    data,
});

export const workingCapitalAcceptanceFail = (offerId, error) => ({
    type: actionTypes.WORKING_CAPITAL_ACCEPTANCE_FAIL,
    offerId,
    error,
});

export const workingCapitalAcceptanceReset = () => ({
    type: actionTypes.WORKING_CAPITAL_ACCEPTANCE_RESET,
});

/**
 * Records the payee's response to a working capital offer. An `acceptedAmount`
 * of 0 denotes a rejection; any other amount is an acceptance and must be
 * accompanied by exactly one of `acceptedHoldbackRate` /
 * `acceptedNumOfRepayments`.
 *
 * @param {WorkingCapitalAcceptancePayload} data
 */
export const postWorkingCapitalAcceptance = (data) => ({
    type: actionTypes.POST_WORKING_CAPITAL_ACCEPTANCE,
    data,
});
